// @flow

import _ from 'lodash';

import { parseRedirectsFromDB } from 'src/helpers/redirect-helpers';
import type { RedirectsState, RedirectsAction } from 'stores/flow-type/redirect.type';

import {
  GET_REDIRECTS_REQUEST,
  GET_REDIRECTS_SUCCESS,
  GET_REDIRECTS_FAILURE,
  BULK_REDIRECTS_REQUEST,
  BULK_REDIRECTS_SUCCESS,
  BULK_REDIRECTS_FAILURE,
  DELETE_REDIRECTS_REQUEST,
  DELETE_REDIRECTS_SUCCESS,
  DELETE_REDIRECTS_FAILURE,
  UPDATE_REDIRECT_REQUEST,
  UPDATE_REDIRECT_SUCCESS,
  UPDATE_REDIRECT_FAILURE,
  VERIFY_CONTENT_REDIRECT_BEFORE_IMPORT_REQUEST,
  VERIFY_CONTENT_REDIRECT_BEFORE_IMPORT_SUCCESS,
  VERIFY_CONTENT_REDIRECT_BEFORE_IMPORT_FAILURE,
  IMPORT_FILE_REDIRECT_REQUEST,
  IMPORT_FILE_REDIRECT_SUCCESS,
  IMPORT_FILE_REDIRECT_FAILURE,
  EXPORT_FILE_REDIRECT_REQUEST,
  EXPORT_FILE_REDIRECT_SUCCESS,
  EXPORT_FILE_REDIRECT_FAILURE
} from 'stores/flow-type/redirect.type';

const initialState: RedirectsState = {
  loading: false,
  success: false,
  successFlag: 0, // Make sure data is updated when calling an API multiply at the same time
  error: null,
  redirects: [],
  total: 0,
  saving: false,

  // Verify file content
  verifying: false,
  fileContentErrorCode: '',
  totalRecord: 0,

  // Import file content
  importing: false,
  totalImportedRecords: 0
};

const redirectReducers = (state: FilterDataState = initialState, action: RedirectsAction) => {
  switch (action.type) {
    // Get redirects
    case GET_REDIRECTS_REQUEST:
      return { ...state, success: false, loading: true };
    case GET_REDIRECTS_SUCCESS: {
      const { data } = action.payload;
      const { data: redirects, total } = data;

      // Parse redirects
      const parsedRedirects = parseRedirectsFromDB(redirects);

      return {
        ...state,
        loading: false,
        success: true,
        successFlag: 1 - state.successFlag,
        error: undefined,
        redirects: parsedRedirects,
        total
      };
    }
    case GET_REDIRECTS_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };

    // Bulk redirects
    case BULK_REDIRECTS_REQUEST:
      return { ...state, success: false, saving: true };
    case BULK_REDIRECTS_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        saving: false,
        success: true,
        successFlag: 1 - state.successFlag,
        error: undefined,
        redirects: data
      };
    }
    case BULK_REDIRECTS_FAILURE:
      return {
        ...state,
        saving: false,
        success: false,
        error: action.payload
      };

    // Delete redirects
    case DELETE_REDIRECTS_REQUEST:
      return { ...state, success: false, deleting: true };
    case DELETE_REDIRECTS_SUCCESS: {
      return {
        ...state,
        deleting: false,
        success: true,
        successFlag: 1 - state.successFlag,
        error: undefined
      };
    }
    case DELETE_REDIRECTS_FAILURE:
      return {
        ...state,
        deleting: false,
        success: false,
        error: action.payload
      };

    // Update redirect
    case UPDATE_REDIRECT_REQUEST:
      return { ...state, success: false, saving: true };
    case UPDATE_REDIRECT_SUCCESS: {
      const { data: response, actionName } = action.payload;

      // Skip update redirects if action is change status
      // Because the status of selected redirect has been changed before
      if (actionName === 'changeStatus') {
        return {
          ...state,
          saving: false,
          success: true,
          successFlag: 1 - state.successFlag,
          error: undefined
        };
      }

      // Parse redirects
      const parsedRedirects = parseRedirectsFromDB(response);

      return {
        ...state,
        saving: false,
        success: true,
        successFlag: 1 - state.successFlag,
        error: undefined,
        redirects: parsedRedirects
      };
    }
    case UPDATE_REDIRECT_FAILURE:
      return {
        ...state,
        saving: false,
        success: false,
        error: action.payload
      };

    // Verify file content
    case VERIFY_CONTENT_REDIRECT_BEFORE_IMPORT_REQUEST:
      return { ...state, success: false, verifying: true, fileContentErrorCode: '' };
    case VERIFY_CONTENT_REDIRECT_BEFORE_IMPORT_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        success: true,
        successFlag: 1 - state.successFlag,
        error: undefined,
        verifying: false,
        totalRecord: data.total,
        fileContentErrorCode: ''
      };
    }
    case VERIFY_CONTENT_REDIRECT_BEFORE_IMPORT_FAILURE:
      return {
        ...state,
        success: false,
        error: action.payload,
        verifying: false,
        fileContentErrorCode: action.payload.errorCode ? action.payload.errorCode : 'ORTHER'
      };

    // Import redirects
    case IMPORT_FILE_REDIRECT_REQUEST:
      return { ...state, success: false, importing: true };
    case IMPORT_FILE_REDIRECT_SUCCESS: {
      const { data: response } = action.payload;
      const totalImportedRecords = _.isArray(response.data) ? response.data.length : 0;

      return {
        ...state,
        importing: false,
        success: true,
        successFlag: 1 - state.successFlag,
        error: undefined,
        totalImportedRecords
      };
    }
    case IMPORT_FILE_REDIRECT_FAILURE:
      return {
        ...state,
        importing: false,
        success: false,
        error: action.payload
      };

    // Export redirects
    case EXPORT_FILE_REDIRECT_REQUEST:
      return { ...state, success: false, exporting: true };
    case EXPORT_FILE_REDIRECT_SUCCESS: {
      return {
        ...state,
        exporting: false,
        success: true,
        successFlag: 1 - state.successFlag,
        error: undefined
      };
    }
    case EXPORT_FILE_REDIRECT_FAILURE:
      return {
        ...state,
        exporting: false,
        success: false,
        error: action.payload
      };

    default:
      return state;
  }
};
export default redirectReducers;
